import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)
// 解决导航栏或者底部导航tabBar中的vue-router在3.0版本以上频繁点击菜单报错的问题。
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}
const routes = [
  {
    path: '/',
    name: 'Manager',
    redirect: '/home',
    component: () => import('../views/Manager.vue'),
    children: [
      {
        path: 'home',
        name: 'Home',
        component: () => import('../views/manager/Home.vue')
      },
      {
        path: '403',
        name: '403',
        component: () => import('../views/manager/403.vue')
      },
      {
        path: 'person',
        name: '个人信息',
        component: () => import('../views/manager/Person.vue')
      },
      {
        path: 'user',
        name: '员工',
        component: () => import('../views/manager/User.vue')
      },
      /*{
        path: 'admin',
        name: '管理员',
        component: () => import('../views/manager/Admin.vue')
      },*/
      {
        path:'suppliers',
        name: '供应商',
        component: () => import('../views/manager/Suppliers.vue')

      },
      {
        path: 'customer',
        name: '客户',
        component: () => import('../views/manager/Customer.vue')
      },
      {
        path: 'product',
        name: '商品',
        component: () => import('../views/manager/Product.vue')
      },
      {
        path: 'productPurchases',
        name: '商品进货',
        component: () => import('../views/manager/ProductPurchases.vue')
      },
        {
          path: 'productReturns',
          name: '商品退货',
          component: () => import('../views/manager/ProductReturns.vue')
        },
        {
          path: 'productSales',
          name: '商品销售',
          component: () => import('../views/manager/ProductSales.vue')
        },
        {
          path: 'productSalesReturns',
          name: '商品销售退货',
          component: () => import('../views/manager/ProductSalesReturns.vue')
        },
      {
        path: 'password',
        name: '修改密码',
        component: () => import('../views/manager/Password.vue')
      }
    ]
  },
  {
    path: '/login',
    name: '登录',
    component: () => import('../views/Login.vue')
  },
    {
      path: '/register',
      name: '注册',
      component: () => import('../views/Register.vue')
    },
    {
      path: '*',
      name: '404',
      component: () => import('../views/404.vue')
    },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  // to 是到达的路由信息
  // from 是开源的路由信息
  // next 是帮助我们跳转路由的函数
  let adminPaths = ['/user']
  let user = JSON.parse(localStorage.getItem('freshman-user') || '{}')

  if (user.role !== '管理员' && adminPaths.includes(to.path)) {
    // 如果当前登录的用户不是管理员，然后当前的到达的路径是管理员才有权限访问的路径，那这个时候我就让用户去到一个没有权限的页面，不让他访问实际的页面
    next('/403')
  } else {
    next()
  }
})

export default router